var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  cacheId: "598677a7c9244ab9bd4d01573ca4befa",
  id: "eMOEyCWHAzs1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 4599 836",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  r: 150.6,
  transform: "translate(4434.2 468.2)",
  fill: "none",
  stroke: "#2575fc",
  strokeWidth: 18.9,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M4366.8,559.3v-182.1h64.9c14.1,0,25.8,2.4,35.1,7.3c8.905483,4.373815,16.240544,11.394515,21,20.1q6.9,12.9,6.9,29.7c0,11.1-2.3,20.9-7,29.3-4.722702,8.636056-12.080159,15.538052-21,19.7-9.3,4.7-21,7.1-35.1,7.1h-49.2v-23.7h46.7c8.9,0,16.1-1.3,21.7-3.8c5.208827-2.247125,9.531826-6.148368,12.3-11.1c2.757477-5.413707,4.131695-11.425911,4-17.5.132128-6.202175-1.240354-12.344031-4-17.9-2.749127-5.122072-7.106226-9.198068-12.4-11.6-5.6-2.7-12.9-4.1-22-4.1h-34.5v158.6Zm89.9-82.2l44.9,82.2h-31.3l-44.1-82.2Z",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("rect", {
  width: 619.9,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "matrix(0-1 1 0 10.1 626.2)",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 416.9,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "translate(10.1 536.6)",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685,210.7c-115.1,0-208.4,93.3-208.4,208.4s93.3,208.5,208.4,208.5s208.5-93.4,208.5-208.5-93.4-208.4-208.5-208.4Zm0,325.9c-64.880412-.055217-117.436785-52.686185-117.399981-117.56661s52.652853-117.451733,117.533286-117.433343s117.466672,52.619518,117.466695,117.499953c.000011,31.180271-12.393144,61.082021-34.450301,83.120422s-51.969439,34.406114-83.149699,34.379578Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1151.4,210.7C1036.3,210.7,943,304,943,419.1s93.3,208.5,208.4,208.5s208.5-93.4,208.5-208.5-93.3-208.4-208.5-208.4Zm0,325.9c-64.880412-.055217-117.436785-52.686185-117.399981-117.56661s52.652853-117.451733,117.533286-117.433343s117.466672,52.619518,117.466695,117.499953c.000011,31.180271-12.393144,61.082021-34.450301,83.120422s-51.969439,34.406114-83.149699,34.379578Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269,210.7v416.9c-.043754,46.797905-27.830719,89.116116-70.755626,107.757418s-92.817441,10.057514-127.044374-21.857418l-67.7,60.9c39.084223,39.477245,92.347992,61.661479,147.9,61.6c115.2,0,208.5-93.3,208.5-208.4v-416.9Z",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1826.3,214.7c0-115.1-93.3-208.4-208.4-208.4s-208.5,93.3-208.5,208.4c-.065131,45.046243,14.537447,88.889078,41.6,124.9l70.5-57.6c-36.269868-51.97997-24.775698-123.358831,25.978286-161.325313s122.473461-28.835529,162.095149,20.637114s32.863911,121.454517-15.273435,162.688199v0l-.7.6-.9.8v0l-71.3,58.1-62.6,51.2v0L1409.4,536.6l57.5,70.4l279.5-228.2c50.528106-39.440498,80.015107-100.00141,79.9-164.1Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 416.9,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "translate(1409.4 536.6)",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2550.7,210.7c-115.1,0-208.4,93.3-208.4,208.4s93.3,208.5,208.4,208.5s208.5-93.4,208.5-208.5-93.4-208.4-208.5-208.4Zm0,325.9c-64.880412-.055217-117.436785-52.686185-117.399981-117.56661s52.652853-117.451733,117.533286-117.433343s117.466672,52.619518,117.466695,117.499953c.000011,31.180271-12.393144,61.082021-34.450301,83.120422s-51.969439,34.406114-83.149699,34.379578Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 416.9,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "matrix(0-1 1 0 2668.2 627.5)",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2292.7,184.7v0c.026549-47.137104-18.686836-92.351221-52.017807-125.682193s-78.545089-52.044356-125.682193-52.017807h-239.2v620.2h239.1c98.2,0,177.8-79.6,177.8-177.9v0c.054963-50.486317-21.403645-98.60452-59-132.3c37.575343-33.710789,59.029534-81.819085,59-132.3Zm-325.3,0v-86.2h147.6c31.478415-1.072626,61.035771,15.108841,77.092792,42.20521s16.057021,60.793211,0,87.88958-45.614377,43.277836-77.092792,42.20521h-147.6Zm147.5,351h-147.5v-172.7h147.5c46.546495,1.584232,83.461038,39.776553,83.461038,86.35s-36.914543,84.765768-83.461038,86.35Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 620.6,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "matrix(0-1 1 0 1875.8 627.6)",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4158.4,214.7c0-115.1-93.3-208.4-208.4-208.4s-208.5,93.3-208.5,208.4c-.065131,45.046243,14.537447,88.889078,41.6,124.9l70.5-57.6c-36.269868-51.97997-24.775698-123.358831,25.978286-161.325313s122.473461-28.835529,162.095149,20.637114s32.863911,121.454517-15.273435,162.688199v0l-.7.6-.9.8v0l-71.3,58.1-62.6,51.2v0L3741.5,536.6L3799,607l279.5-228.2c50.528106-39.440498,80.015107-100.00141,79.9-164.1Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 416.9,
  height: 90.91,
  rx: 0,
  ry: 0,
  transform: "translate(3741.5 536.6)",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3075.9,317.3c26.833157,15.466362,46.460569,40.917291,54.6,70.8l87.8-23.5c-14.345418-53.17211-49.192894-98.484617-96.9-126-99.7-57.6-227.2-23.4-284.8,76.3-7.644716,13.217904-13.815021,27.235226-18.4,41.8l7.4,4.3v0l337.6,194.9l45.5-78.7L2946,325.5c37.692697-28.656678,88.902935-31.889349,129.9-8.2Z",
  fill: "#4d91ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3133.8,434c-7.228341,55.741236-52.891025,98.574771-108.980135,102.227991s-106.922142-32.895314-121.319865-87.227991l-87.8,23.5c14.14622,53.637443,49.14117,99.397299,97.2,127.1c99.7,57.6,227.2,23.4,284.8-76.3c7.644716-13.217904,13.815021-27.235226,18.4-41.8Z",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3483.6,627.6c49.165568.03642,96.751516-17.360975,134.3-49.1L3560.4,508c-28.490472,24.620189-67.047714,34.108667-103.710046,25.521807s-66.995782-34.210557-81.589954-68.921807h-95c20.7,93.2,104,163,203.5,163Z",
  fill: "#2575fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3692,419.1v0c0-1.9,0-3.7-.1-5.6v-1.9c-.1-1.2-.1-2.5-.2-3.7s-.1-1.4-.1-2.2l-.3-3.4c-.017145-.736995-.083963-1.471995-.2-2.2l-.3-3.3c-.1-.7-.1-1.5-.2-2.3-.188585-1.059031-.322097-2.127134-.4-3.2-.093084-.773125-.226601-1.540843-.4-2.3-.1-1-.3-2.1-.4-3.1-.181622-.757481-.315221-1.525677-.4-2.3l-.6-3.1c-.1-.8-.3-1.5-.4-2.3s-.4-2.1-.7-3.1c-.041795-.477266-.142562-.947515-.3-1.4v0c-20.7-93.3-103.9-163-203.4-163-97.629507-.011793-182.19476,67.72352-203.5,163v0l-.3,1.4c-.2,1-.5,2.1-.7,3.2s-.3,1.4-.4,2.2l-.6,3.1-.3,2.3c-.2,1-.4,2.1-.5,3.1l-.3,2.3c-.2,1.1-.3,2.2-.4,3.2l-.3,2.3-.3,3.3c-.1.7-.1,1.5-.2,2.2s-.2,2.3-.2,3.5-.1,1.4-.2,2.1-.1,2.5-.1,3.8c-.082979.596209-.116427,1.198268-.1,1.8-.1,1.8-.1,3.7-.1,5.6v.6c0,1.8.1,3.5.1,5.3v.6c.411018,13.124559,2.051529,26.181685,4.9,39v0v.3h95.1l-.2-.3h312c3.341166-14.935593,5.018053-30.195262,5-45.5ZM3483.6,301.6c47.362133-.010171,90.100079,28.416083,108.4,72.1h-216.9c18.335572-43.699638,61.10959-72.123663,108.5-72.1Z",
  fill: "#4d91ff"
}))));
export default __webpack_public_path__ + "static/media/Log2Base2TextLogo.fa62cacc.svg";
export { SvgComponent as ReactComponent };